import 'css-chunksrc/client/pages/projectPage/wbsPage/exportButton/loader/styles.scss';export default {
  "loader": "_loader_odvgy_1",
  "spin": "_spin_odvgy_1"
};